export default {
  mounted () {
    setTimeout(() => {
      if (!this.globalStyles.hasOwnProperty('code_injection')) {
        this.$set(this.globalStyles, 'code_injection', {
          head: '',
          body: ''
        })
      }

      const shouldIgnoreHeadScript = $s => {
        if (
          $s.tagName !== 'SCRIPT' ||
          typeof $s.getAttribute !== 'function'
        ) {
          return false
        }

        const src = ($s.getAttribute('src') || '').toLowerCase()
        const text = ($s.textContent || '').toLowerCase()

        return src.includes('cookie-script.com') ||
          src.includes('equalweb.com') ||
          text.includes('window.interdeal') ||
          text.includes('equalweb.com')
      }

      const insert = (script, container, type) => {
        const vWrapper = document.createElement('div'),
          wrapper = document.createElement('div'),
          oldWrapper = document.querySelector('[global-code-injection]')
        vWrapper.innerHTML = script

        if (oldWrapper) {
          oldWrapper.parentNode.removeChild(oldWrapper)
        }

        wrapper.setAttribute('global-code-injection', true)

        const scripts = vWrapper.children

        if (scripts && scripts.length > 0) {
          Array.from(scripts).forEach($s => {

            // Ignore tracking/accessibility loaders in head during builder rendering.
            if (type === 'head' && shouldIgnoreHeadScript($s)) {
              return
            }

            var dEl = document.createElement($s.tagName),
              attrs = $s.attributes

            dEl.innerHTML = $s.innerHTML
            for (var i = attrs.length - 1; i >= 0; i--) {
              dEl.setAttribute(attrs[i].name, attrs[i].value)
            }
            wrapper.appendChild(dEl)
          })

          container.appendChild(wrapper)
        }
      }

      insert(this.globalStyles.code_injection.head, document.head, 'head')
      insert(this.globalStyles.code_injection.body, document.body, 'body')
    }, 1000)
  }
}
